import React from 'react';

const ColorBullet = ({ color, text, size }) => {
	
	if (size === undefined) {
		size = 20;
	}

	const containerStyle = {
		whiteSpace: 'nowrap',
		fontSize: '.9em',
		display: 'inline-flex',
		alignItems: 'center',
		gap: '5px',
		lineHeight: 1.2,
	};

	const bulletStyle = {
		backgroundColor: color,
		width: `${size}px`,
		height: `${size}px`,
		borderRadius: '50%',
		flexShrink: 0,
		display: 'inline-block',
	};

	const labelStyle = {
		lineHeight: 1.2,
	};

	return (
		<div style={containerStyle}>
			<span style={bulletStyle}></span>
			{text !== undefined && <span style={labelStyle}>{text}</span>}
		</div>
	);
}

export default ColorBullet;